module.exports = __webpack_public_path__ + "img/C00051.3dbd23a8.png";